export const POSTGRAD_ASSESSMENTS_CARD_ROW_ICON_NAMES = {
  passed: 'check',
  retry: 'replay',
  waiting_grading: 'mockTest',
  available: 'library',
  unavailable: 'locker',
  tccInProgress: 'school',
};
